import { motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { heroVariant, staggerContainer, itemVariant, viewportOnce } from "@/lib/motion";
import { usePageContent } from "@/hooks/usePageContent";

const fallback = {
  label: "Resources",
  headline: "Guides & E-books",
  subheadline: "In-depth resources to accelerate your growth.",
  guides: [
    { title: "The Complete CRO Playbook", type: "Guide", description: "50+ page guide to conversion optimization" },
    { title: "Performance Marketing Benchmark Report", type: "Report", description: "Industry benchmarks across channels" },
    { title: "AI in Marketing: 2025 Outlook", type: "E-book", description: "How AI is reshaping marketing operations" },
    { title: "Email Marketing Automation Guide", type: "Guide", description: "Build lifecycle email programs that convert" },
  ],
};

const Guides = () => {
  const { content } = usePageContent("guides", fallback);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <section className="relative pt-28 pb-10 md:pt-36 md:pb-16 lg:pt-44 lg:pb-20">
        <div className="container-wide">
          <motion.div initial="hidden" animate="visible" variants={staggerContainer} className="max-w-3xl">
            <motion.span variants={heroVariant} className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-medium mb-4 block">
              {content.label}
            </motion.span>
            <motion.h1 variants={heroVariant} className="font-display text-4xl md:text-5xl font-semibold text-foreground mb-6">
              {content.headline}
            </motion.h1>
            <motion.p variants={heroVariant} className="text-lg text-muted-foreground">
              {content.subheadline}
            </motion.p>
          </motion.div>
        </div>
      </section>
      <section className="py-10 md:py-16 border-t border-border">
        <div className="container-wide">
          <motion.div className="grid md:grid-cols-2 gap-8" initial="hidden" whileInView="visible" viewport={viewportOnce} variants={staggerContainer}>
            {content.guides.map((guide: any) => (
              <motion.div key={guide.title} variants={itemVariant} className="p-6 border border-border hover:border-primary/30 transition-colors">
                <span className="text-xs text-primary uppercase tracking-wider">{guide.type}</span>
                <h3 className="text-xl font-medium text-foreground mt-2 mb-2">{guide.title}</h3>
                <p className="text-sm text-muted-foreground mb-4">{guide.description}</p>
                <Button variant="outline" size="sm">
                  <Download className="h-4 w-4 mr-2" />
                  Download
                </Button>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Guides;
